<template>
    <div class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th v-for="(value, key, index) in columns" :key="`thead-${index}`" :class="`col-${key.replace(/_/g, '-')}`">
                        <div @click="sortBy(key)" v-if="sortable.includes(key)" class="sortable flex-container align-middle align-justify">
                            {{ value }}
                            <svg viewBox="0 0 7 12.17" width="12" height="12" fill="#7a7a7a">
                                <path d="M396,308.5l-3.5-4h7Z" transform="translate(-392.5 -296.33)" :fill="fallbackSort == key && sortOrder == 'asc' ? '#00783a' : ''"/>
                                <path d="M399.5,300.33h-7l3.5-4Z" transform="translate(-392.5 -296.33)" :fill="fallbackSort == key && sortOrder == 'desc' ? '#00783a' : ''"/>
                            </svg>
                        </div>
                        <div v-else>
                            {{ value }}
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in sorted" :key="`tr-${index}`">
                    <td v-for="(value, key, index) in row" v-if="Object.keys(columns).includes(key)" :key="`cell-${index}`" :class="`col-${key.replace(/_/g, '-')}`">
                        <slot :value="value" :name="key">{{ value || '-' }}</slot>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import orderBy from 'lodash/orderBy';

export default {
    props: {
        columns: {
            default: {},
            required: true,
        },
        rows: {
            default: [],
            required: true,
        },
        sortable: {
            default: () => [],
        },
        defaultSort: {
            default: '',
        },
    },
    data () {
        return {
            sortKey: '',
            sortOrder: ['asc'],
        };
    },
    computed: {
        fallbackSort () {
            if (this.sortKey) {
                return this.sortKey;
            } else {
                return this.defaultSort ? this.defaultSort : this.sortable[0];
            }
        },
        reduced () {
            return this.rows.map(row => Object.keys(this.columns).reduce((a, e) => (a[e] = row[e], a), {}));
        },
        sorted () {
            return orderBy(this.reduced, this.fallbackSort, this.sortOrder);
        },
    },
    methods: {
        sortBy (key) {
            if (key == this.sortKey) {
                this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
            } else {
                this.sortKey = key;
                this.sortOrder = 'asc';
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.sortable {
    cursor: pointer;
    user-select: none;
}
.col-new-price-date {
    width: 180px;
}

.col-provider {
    font-weight: 700;
    tbody & {
        color: $c-atelier;
    }
}
.table-wrapper {
    table {
        max-width: calc(100% - 32px);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/BmrTable.vue